import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { AuthProvider } from './state/auth-context';
import { NotificationsProvider } from './state/notifications-context';
import { ThemeProvider } from './theme/theme-context';

/**
 * Root application component. Wraps the app in AuthProvider for
 * authentication state, NotificationsProvider for notification state,
 * ThemeProvider for theme mode management, then uses React Router's
 * data router pattern.
 *
 * Provider order: AuthProvider → NotificationsProvider → ThemeProvider → RouterProvider
 */
export function App(): React.ReactElement {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </NotificationsProvider>
    </AuthProvider>
  );
}
